import * as Sentry from '@sentry/react';
import type { ReactNode } from 'react';

function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed') ||
    error.name === 'ChunkLoadError'
  );
}

function ErrorFallback({ error }: { error?: unknown }) {
  // Chunk load error = stale deploy cache → reload silently
  if (isChunkLoadError(error)) {
    window.location.reload();
    return null;
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FB] dark:bg-gray-950 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-800 p-8 max-w-md w-full text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
          <span className="text-red-600 dark:text-red-400 text-xl">!</span>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Algo sali&oacute; mal
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Ocurri&oacute; un error inesperado. Por favor, recarga la p&aacute;gina para continuar.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-[#6D5DFE] hover:bg-[#5B4DE0] text-white px-6 py-2.5 rounded-xl shadow-md shadow-purple-200 dark:shadow-purple-900/30 transition-all font-medium"
        >
          Recargar p&aacute;gina
        </button>
      </div>
    </div>
  );
}

interface AppErrorBoundaryProps {
  children: ReactNode;
}

export function AppErrorBoundary({ children }: AppErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary fallback={({ error }) => <ErrorFallback error={error} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
